<template>
  <!-- APK下载确认弹窗 -->
  <van-overlay v-model:show="props.show" class="apk-overlay">
    <div class="apk-dialog-wrapper" @click.stop>
      <div class="apk-dialog-container">
        <!-- 这里用一个透明的站位，防止背景图被遮挡 -->
        <div class="apk-dialog-bg-placeholder">

        </div>
        <!-- 背景图区域 -->
        <div class="apk-dialog-bg">
          <img src="@/assets/images/installapkpop.png" alt="background" class="bg-image" />
        </div>
        
        <!-- 内容区域 -->
        <div class="apk-dialog-content">
          <!-- 标题 -->
          <h3 class="apk-dialog-title">{{ t('installPwa.apkDialog.title') }}</h3>
          
          <!-- 按钮区域 -->
          <div class="apk-dialog-buttons">
            <button class="apk-cancel-btn" @click="handleApkDialogCancel">
              {{ t('installPwa.apkDialog.cancelButton') }}
            </button>
            <button class="apk-confirm-btn" @click="handleApkDialogConfirm">
              {{ t('installPwa.apkDialog.confirmButton') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script setup>
import { ref, onMounted, computed, } from 'vue'
import { useI18n } from 'vue-i18n'
import { downloadAPK } from '@/utils/pub-use'
import { trackApkDownloadPromptDismissed, trackApkDownloadPromptConfirmed } from '@/utils/firebase-analytics'
const { t } = useI18n()

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:show'])

const handleApkDialogCancel = () => {
    emit('update:show', false)
    trackApkDownloadPromptDismissed()
}

const handleApkDialogConfirm = async () => {
    trackApkDownloadPromptConfirmed()
    emit('update:show', false)
    await downloadAPK()
}
</script>

<style lang="scss">

// APK下载弹窗样式
.apk-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 99999 !important;
}

.apk-dialog-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.apk-dialog-container {
  position: relative;
  width: 320px;
  max-width: 90vw;
  // background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  z-index: 100000;
  transform: translateY(-80px);
}

.apk-dialog-bg-placeholder {
  width: 100%;
  height: 100px;
  background-color: transparent;
}

.apk-dialog-bg {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;

  .bg-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}

.apk-dialog-content {
  position: relative;
  background: #fff;
  padding: 20px;
  text-align: center;
}

.apk-dialog-title {
  font-size: 14px;
  // font-weight: 600;
  color: #333;
  margin: 12px 0 24px 0;
  line-height: 1.4;
}

.apk-dialog-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
}

.apk-cancel-btn,
.apk-confirm-btn {
  flex: 1;
  height: 32px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  // font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.apk-cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #e0e0e0;

  &:hover {
    background: #ebebeb;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
}

.apk-confirm-btn {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: #fff;

  &:hover {
    background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(76, 175, 80, 0.2);
  }
}

</style>